import React, { useState } from 'react'
import { Display } from '../Main/styles'
import BranchTable from './BranchTable'
import BranchFilter from './BranchFilter'
import { useFilterList } from 'CRM/hooks/GetFilterList'
import { useBranchList } from 'CRM/hooks/GetBranchList'
import dayjs from "dayjs";
import { RangePickerProps } from 'rc-picker/es/RangePicker.d';
import {useIsMobile} from "../../components/IsMobile";
import {ReactComponent as FilterArrowBottom} from "../../../assets/FilterArrowBottom.svg";
import styled from "styled-components";

export const Branch = () => {
	const IsMobile = useIsMobile();
	const { filterList: resList } = useFilterList('responsibility')
	const { filterList: teamList } = useFilterList('team')
	const { filterList: bList } = useFilterList('branch')
	const { branchList, mutate } = useBranchList()

	const [respon, setRespon] = useState('')
	const [team, setTeam] = useState('')
	const [branch, setBranch] = useState('')
	const [name, setName] = useState('')
	const [address, setAddress] = useState('')
	const [depositAt, setDepositAt] = useState<RangePickerProps<dayjs.Dayjs>['value'] | any>([null, null]);
	const [withdrawAt, setWithdrawAt] = useState<RangePickerProps<dayjs.Dayjs>['value'] | any>([null, null]);

	const [isFilter, setIsFilter] = useState(false);

	return (
		<Display IsMobile={IsMobile}>

			{IsMobile &&
				<div style={{
					backgroundColor: 'white',
					width: '100%',
					height: 40,
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					zIndex: 2,
					boxShadow: '2px 2px 8px 2px #74747476',
					cursor: 'pointer',
					marginBottom: !isFilter ? 20 : 0
				}} onClick={() => setIsFilter(!isFilter)}>
					<div style={{marginLeft: 15}}>필터</div>
					{isFilter ?
						<RotatedSvg style={{width: 45, height: 25}}/>
						:
						<FilterArrowBottom style={{width: 45, height: 25}}/>
					}
				</div>
			}

			{IsMobile ?
				<>
					{isFilter &&
						<BranchFilter
							resList={resList}
							teamList={teamList}
							branchList={branchList}
							name={name}
							setName={setName}
							respon={respon}
							setRespon={setRespon}
							team={team}
							setTeam={setTeam}
							branch={branch}
							setBranch={setBranch}
							address={address}
							setAddress={setAddress}
							depositAt={depositAt}
							setDepositAt={setDepositAt}
							withdrawAt={withdrawAt}
							setWithdrawAt={setWithdrawAt}
							bList={bList}
						/>
					}
				</>
				:
				<BranchFilter
					resList={resList}
					teamList={teamList}
					branchList={branchList}
					name={name}
					setName={setName}
					respon={respon}
					setRespon={setRespon}
					team={team}
					setTeam={setTeam}
					branch={branch}
					setBranch={setBranch}
					address={address}
					setAddress={setAddress}
					depositAt={depositAt}
					setDepositAt={setDepositAt}
					withdrawAt={withdrawAt}
					setWithdrawAt={setWithdrawAt}
					bList={bList}
				/>
			}


			<BranchTable
				mutate={mutate}
				resList={resList}
				teamList={teamList}
				branchList={branchList}
				respon={respon}
				team={team}
				branch={branch}
				name={name}
				address={address}
				depositAt={depositAt}
				withdrawAt={withdrawAt}
				bList={bList}
			/>
		</Display>
	)
}

export default React.memo(Branch)

const RotatedSvg = styled(FilterArrowBottom)`
  transform: rotate(180deg);
  width: 45px;
  height: 25px;
`;